export default __webpack_public_path__ + "a3fdde1d628579c3b758ce8b3922d94a.png";